    import { Typography, TypographyProps } from "@mui/material"

    interface DamsLabelProps extends TypographyProps {
        title?: string
    }

    function SimpleLabel({ title = 'label Title',...props }: DamsLabelProps) {
        return (
            <Typography
                {...props}
                fontFamily={'Inter'}
                fontSize={14}
                fontWeight={props.fontWeight??600}
                noWrap
                width={props.width??280}
                textAlign={'left'}
            >
                {title}
            </Typography>
        )
    }


    export { SimpleLabel }
